import { d as i, c as e } from "../../../index-34b1f277.js";
import { SearchAnimatedInputAnatomy as n } from "./SearchAnimatedInput.anatomy.es.js";
const { defineMultiStyleConfig: a, definePartsStyle: o } = e(
  n.keys
), t = o({
  control: i({
    minHeight: "size-500",
    paddingLeft: "spacing-100",
    paddingRight: "spacing-50",
    minWidth: "284px",
    display: "inline-flex",
    flexDirection: "column",
    backgroundColor: "primary.600",
    position: "relative",
    borderRadius: "full",
    transition: "min-width 300ms ease",
    _hover: {
      transition: "outline-color 150ms ease",
      outlineWidth: "4px",
      outlineStyle: "solid",
      outlineColor: "primary.400",
      input: {
        _placeholder: {
          color: "white"
        }
      },
      '[data-left-addon="search"]': {
        svg: {
          color: "white"
        }
      }
    },
    '&[data-expandible="true"]': {
      "&:has(input:focus)": {
        minWidth: "500px"
      },
      "&:has(input:not(:placeholder-shown))": {
        transition: "width 300ms ease",
        minWidth: "500px"
      }
    },
    '&[data-expandible="false"]': {
      "&:has(input:focus)": {
        maxWidth: "248px"
      },
      "&:has(input:not(:placeholder-shown))": {
        maxWidth: "248px"
      }
    },
    "&:has(input:focus)": {
      transition: "min-width 300ms ease",
      outlineWidth: "4px",
      outlineStyle: "solid",
      outlineColor: "rgba(246, 153, 60, 0.70)",
      backgroundColor: "white",
      _hover: {
        input: {
          _placeholder: {
            color: "primary.300"
          }
        }
      },
      input: {
        paddingRight: "spacing-100"
      },
      '[data-left-addon="search"]': {
        svg: {
          color: "primary.700"
        }
      }
    },
    "&:has(input:not(:placeholder-shown))": {
      backgroundColor: "white"
    }
  }),
  addon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "primary.300"
  },
  leftAddon: i({
    boxSize: "size-300",
    padding: "spacing-200",
    paddingRight: "spacing-200"
  }),
  leftIcon: i({
    color: "primary.200"
  }),
  rightAddon: i({}),
  clear: i({
    minWidth: "size-200",
    minHeight: "size-200",
    padding: "spacing-100"
  }),
  field: i({
    transition: "min-width 300ms ease",
    minHeight: "size-500",
    width: "full",
    border: "none",
    outline: "none",
    background: "transparent",
    color: "primary.500",
    _placeholder: {
      color: "primary.300"
    }
  }),
  group: {
    position: "relative",
    display: "inline-flex",
    width: "full",
    borderRadius: "full",
    alignItems: "center",
    '& > [data-right-addon="clear"]': {
      display: "none"
    },
    "&:has(input:focus)": {
      '& > [data-right-addon="clear"]': {
        display: "inline-block"
      }
    },
    "&:has(input:not(:placeholder-shown))": {
      '[data-left-addon="search"]': {
        svg: {
          color: "primary.700"
        }
      },
      '& > [data-right-addon="clear"]': {
        display: "inline-block"
      }
    },
    "&:has(input:placeholder-shown)": {
      '& > [data-right-addon="clear"]': {
        '& > [data-icon-button="clear"]': {
          color: "primary.300",
          _hover: {
            backgroundColor: "unset"
          }
        }
      }
    }
  }
}), d = a({
  baseStyle: t
});
export {
  d as SearchAnimatedInput
};
//# sourceMappingURL=SearchAnimatedInput.es.js.map
